/**
 * ページ上に並列配置された複数の Algolia carousel（TOP / PDP / 固定ページ）を
 * Algolia multipleQueries で 1 リクエストに集約するため、
 * 各 carousel の設定 (CarouselSettings) を BatchQuery 配列に変換する純粋関数。
 *
 * .claude/rules/business/logic-separation.md に従い UI から独立させ、
 * DOM 操作と無関係に unit test 可能な形にしている。
 *
 * section ごとに displayNum を変えたい運用に対応するため、
 * 各 CarouselSettings 内の displayNum をそのまま使う。
 */

import {
  buildSearchParams,
  buildIndexName,
  type AlgoliaQueryParams,
  type CarouselSettings,
} from './carousel.logic';
import type { AlgoliaCustomer } from './utils/algolia-filters';

export interface BatchQuery {
  indexName: string;
  params: AlgoliaQueryParams;
}

/**
 * 返り値の配列順は入力 carousels の順に対応する。
 * 呼び出し側が `response.results[i]` を `carousels[i]` に
 * 対応付けて使う前提（multipleQueries のレスポンス順序保証に依存）。
 */
export function buildBatchQueriesForCarousels(
  carousels: CarouselSettings[],
  baseIndexName: string,
  customer: AlgoliaCustomer | null,
): BatchQuery[] {
  return carousels.map((carousel) => ({
    indexName: buildIndexName(baseIndexName, carousel.sortIndex),
    params: buildSearchParams(carousel, customer),
  }));
}
